import { Link } from "@remix-run/react";
import { useTranslation } from "react-i18next";

export function LegalSection() {
	const { t } = useTranslation();

	const routes = [
		{
			name: t("legal:page.routes.communityGuidelines"),
			path: "/legal/community-guidelines",
		},
		{
			name: t("legal:page.routes.termsOfUse"),
			path: "/legal/terms-of-use",
		},
		{
			name: t("legal:page.routes.privacyPolicy"),
			path: "/legal/privacy-policy",
		},
		{
			name: t("legal:page.routes.cookiePolicy"),
			path: "/legal/cookie-policy",
		},
		{
			name: t("legal:page.routes.underagePolicy"),
			path: "/legal/underage-policy",
		},
		{
			name: t("legal:page.routes.contentRemovalPolicy"),
			path: "/legal/content-removal",
		},
		{
			name: t("legal:page.routes.blockedContentPolicy"),
			path: "/legal/blocked-content",
		},
		{
			name: t("legal:page.routes.dmcaPolicy"),
			path: "/legal/dmca-policy",
		},
		{
			name: t("legal:page.routes.complaintPolicy"),
			path: "/legal/complaint-policy",
		},
		{
			name: t("legal:page.routes.usc2257Exemption"),
			path: "/legal/usc-2257-exemption",
		},
	];

	return (
		<section className="px-8 py-12">
			<h1 className="mb-6 font-bold text-2xl">{t("legal:page.title")}</h1>
			<div className="grid grid-cols-1 gap-6 lg:grid-cols-3 md:grid-cols-2">
				{routes.map(({ name, path }) => (
					// w-full border border-gray-500 rounded-xl text-center   transition-all px-4 py-2
					<Link
						className="w-full rounded-xl border border-gray-400 px-4 py-2 text-center transition-all hover:bg-primary hover:text-white"
						key={path}
						to={path}
					>
						{name}
					</Link>
				))}
			</div>
		</section>
	);
}
